import React, { Key } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Item } from 'react-stately';
import { Filter } from '@saucelabs/ds-filters';
import { constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';
import { IconOsOutline } from '@saucelabs/ds-icons';

import actions from '../actions';
import utils, { FilterOsValue } from '../utils';
import selectors from '../selectors';
import constants from '../constants';

const { APP_STORAGE_KIND } = appStorageConstants;
const { FILTER_OS_VALUE_ALL } = constants;

const FILTER_OPTIONS = [
  { value: FILTER_OS_VALUE_ALL, label: 'All' },
  { value: APP_STORAGE_KIND.IOS, label: 'iOS' },
  { value: APP_STORAGE_KIND.ANDROID, label: 'Android' },
] as const;

const Filters: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const currentValue = useSelector(selectors.filterOsSelector);
  return (
    <Filter
      data-qa="app-management-groups-filter"
      defaultSelectedKeys={new Set<Key>().add(currentValue)}
      icon={IconOsOutline}
      label="OS"
      name="os"
      onSelectionChange={(selectedValue) => {
        void dispatch(actions.fetchGroups({
          osFilters: typeof selectedValue === 'string' ?
            utils.constructOsFilters(selectedValue) :
            utils.constructOsFilters([...selectedValue][0] as FilterOsValue),
          paginationPage: 1,
        }));
      }}
      selectionMode="single"
    >
      {FILTER_OPTIONS.map((item) => <Item key={item.value}>{item.label}</Item>)}
    </Filter>
  );
};

export default Filters;
